module.exports = __webpack_public_path__ + "static/media/revenue-source.5793b0fb.png";